import {
  ATTENDANT_PACKAGES,
  NURSE_PROCEDURES,
  PHYSIO_THERAPY_SESSIONS,
  resolveAttendantPackagePrice,
  resolveNurseProcedurePrice,
  resolvePhysioSessionPrice,
  getServiceStepTitle,
} from "../../config/careHubBookingConfig";

export default function CareHubBookingServiceStep({
  role,
  caregiver,
  packageKey,
  onPackageKeyChange,
  tierId,
  onTierIdChange,
  procedureId,
  onProcedureIdChange,
  procedureQuery,
  onProcedureQueryChange,
  sessionId,
  onSessionIdChange,
}) {
  const caregiverPackages =
    caregiver?.packages || caregiver?.profileExtended?.attendantCareHub?.packages || null;

  if (role === "nurses") {
    const q = String(procedureQuery || "").trim().toLowerCase();
    const filtered = NURSE_PROCEDURES.filter((p) => {
      if (!q) return true;
      return p.label.toLowerCase().includes(q);
    });

    return (
      <div className="cabd__service-step">
        <div className="cabd__service-head">
          <h2 className="cabd__title">{getServiceStepTitle(role)}</h2>
          <span className="cabd__service-count">{NURSE_PROCEDURES.length} Services Listed</span>
        </div>
        <input
          type="search"
          className="cabd__procedure-search"
          placeholder="Search procedures (e.g. Injection, Catheter, Dressing)..."
          value={procedureQuery}
          onChange={(e) => onProcedureQueryChange(e.target.value)}
        />
        <div className="cabd__procedure-grid">
          {filtered.map((proc) => {
            const selected = procedureId === proc.id;
            const price = resolveNurseProcedurePrice(proc, caregiver);
            if (price == null) return null;
            return (
              <button
                key={proc.id}
                type="button"
                className={`cabd__procedure${selected ? " is-selected" : ""}`}
                onClick={() => onProcedureIdChange(proc.id)}
              >
                <div className="cabd__procedure-main">
                  <strong>{proc.label}</strong>
                  <span>{proc.durationMinutes} minutes</span>
                </div>
                <span className="cabd__procedure-price">₹{price}</span>
              </button>
            );
          })}
        </div>
      </div>
    );
  }

  if (role === "physio") {
    return (
      <div className="cabd__service-step">
        <div className="cabd__service-head">
          <h2 className="cabd__title">{getServiceStepTitle(role)}</h2>
          <span className="cabd__service-count">{PHYSIO_THERAPY_SESSIONS.length} Services Listed</span>
        </div>
        <div className="cabd__therapy-grid">
          {PHYSIO_THERAPY_SESSIONS.map((session) => {
            const selected = sessionId === session.id;
            const price = resolvePhysioSessionPrice(session, caregiver);
            return (
              <button
                key={session.id}
                type="button"
                className={`cabd__therapy${selected ? " is-selected" : ""}`}
                onClick={() => onSessionIdChange(session.id)}
              >
                <div>
                  <strong>{session.label}</strong>
                  <span>Min {session.durationMinutes} mins</span>
                </div>
                <span className="cabd__therapy-price">₹{price}</span>
              </button>
            );
          })}
        </div>
      </div>
    );
  }

  const hygiene = ATTENDANT_PACKAGES.find((p) => p.id === "hygiene_personal");
  const companion = ATTENDANT_PACKAGES.find((p) => p.id === "companion");
  const hygieneSelected = packageKey === "hygiene_personal";
  const hygienePrice = resolveAttendantPackagePrice(hygiene, null, caregiverPackages);

  return (
    <div className="cabd__service-step">
      <h2 className="cabd__title">{getServiceStepTitle(role)}</h2>
      <div className="cabd__packs">
        <button
          type="button"
          className={`cabd__pack cabd__pack--primary${hygieneSelected ? " is-selected" : ""}`}
          onClick={() => onPackageKeyChange("hygiene_personal")}
        >
          <div className="cabd__pack-top">
            <span className="cabd__pack-badge">Service Pack 1</span>
            <span className="cabd__pack-price-inline">₹{hygienePrice} (approx)</span>
          </div>
          <strong className="cabd__pack-title">{hygiene?.title}</strong>
          <span className="cabd__pack-duration">Duration: {hygiene?.durationLabel}</span>
          <ul className="cabd__pack-tasks">
            {(hygiene?.tasks || []).slice(0, 6).map((t) => (
              <li key={t}>{t}</li>
            ))}
          </ul>
        </button>

        <div className="cabd__pack-stack">
          <h3 className="cabd__pack-stack-title">Service Pack 2: Companion Service</h3>
          {(companion?.tiers || []).map((tier) => {
            const key = `companion:${tier.id}`;
            const selected = packageKey === key;
            const price = resolveAttendantPackagePrice(companion, tier.id, caregiverPackages);
            const tierLabel = tier.label.replace("–", "-").replace("1 hr", "1");
            return (
              <button
                key={tier.id}
                type="button"
                className={`cabd__pack cabd__pack--tier${selected ? " is-selected" : ""}`}
                onClick={() => {
                  onPackageKeyChange(key);
                  onTierIdChange(tier.id);
                }}
              >
                <div className="cabd__pack-tier-row">
                  <strong>Companion Service ({tierLabel})</strong>
                  <span>₹{price} (approx)</span>
                </div>
                <span className="cabd__pack-duration">
                  Duration: {tier.label} (Hospital / Other visits)
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
